export const serviceSections = [
  {
    id: 1,
    title: "Operaciones de reemplazo",
    content: (
      <div>
        <h6 className="font-semibold">Aceite y Filtro de Motor</h6>
        <h6 className="mb-4">Sustitución de aceite y filtro.</h6>

        <h6 className="font-semibold">Filtro de combustible Nafta</h6>
        <h6 className="mb-4">
          Sustitución del filtro de combustible cada 45.000 km. (Incluido en el
          Servicio de 45.000 km)
        </h6>

        <h6 className="font-semibold">Filtro de Aire</h6>
        <h6 className="mb-4">Sustitución filtro de aire.</h6>

        <h6 className="font-semibold">Filtro de habitáculo</h6>
        <h6 className="mb-4">Sustitución filtro de habitáculo.</h6>

        <h6 className="font-semibold">
          Bujías de encendido (motorización nafta)
        </h6>
        <h6>Sustitución de bujías de encendido.</h6>
      </div>
    ),
  },
  {
    id: 2,
    title: "Motor",
    content: "Contenido de Motor",
  },
  {
    id: 3,
    title: "Transmisión",
    content: "Contenido de Transmisión",
  },
  {
    id: 4,
    title: "Frenos",
    content: "Contenido de Frenos",
  },
  {
    id: 5,
    title: "Suspensión - Dirección",
    content: "Contenido de Suspensión y Dirección",
  },
  {
    id: 6,
    title: "Neumáticos",
    content: "Contenido de Neumáticos",
  },
  {
    id: 7,
    title: "Carrocería",
    content: "Contenido de Carrocería",
  },
  {
    id: 8,
    title: "Electricidad - Confort",
    content: "Contenido de Electricidad y Confort",
  },
];
